import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, EMPTY, Observable, throwError } from "rxjs";
import notify from 'devextreme/ui/notify';
import { AuthService } from "../settings/auth.service";

@Injectable()
export class ErrorHttpInterceptor implements HttpInterceptor {

  constructor(private readonly authService: AuthService) { }

  private processErrorMessage(message: string, statusCode: number): string {
    // Pour les erreurs 502/503, fournir un message plus court et plus lisible
    if (statusCode === 502 || statusCode === 503) {
      return `Erreur ${statusCode} - Service temporairement indisponible. Veuillez réessayer dans quelques instants.`;
    }

    // Pour les autres erreurs, nettoyer le message HTML et le limiter en taille
    let cleanMessage = message;
    
    // Supprimer les balises HTML
    cleanMessage = cleanMessage.replace(/<[^>]*>/g, '');
    
    // Limiter à 500 caractères et ajouter "..." si tronqué
    if (cleanMessage.length > 500) {
      cleanMessage = cleanMessage.substring(0, 497) + "...";
    }
    
    // Remplacer les sauts de ligne par des <br />
    cleanMessage = cleanMessage.replaceAll("\n", "<br />");
    
    return cleanMessage;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(catchError(err => {
      const toastOptions = {
        closeOnClick: true,
        contentTemplate: null
      };

      if (err.status == 401) {
        this.authService.logout();
        toastOptions.contentTemplate = "Votre connexion a expiré. Merci de vous reconnecter pour continuer.";
        notify(toastOptions, "error", 20000);
        return EMPTY;
      }

      if (err.status != null) {
        let message = err.error ?? "erreur inconnue";

        if (message instanceof Blob) {
          message.text().then(text => {
            // Limiter la taille du message et nettoyer le HTML pour les erreurs 502/503
            const cleanMessage = this.processErrorMessage(text, err.status);
            toastOptions.contentTemplate = "Une erreur est survenue sur le serveur :<br />" + cleanMessage;
            notify(toastOptions, "error", 20000);
          });

          return EMPTY;
        }

        if (!(typeof message === 'string' || message instanceof String)){
          message = JSON.stringify(message);
        }

        if (err.error == null && err.status == 403) {
          message = "Vous n'avez pas la permission pour faire cette action.";
        }

        // Traiter le message d'erreur pour les erreurs serveur
        const processedMessage = this.processErrorMessage(message, err.status);
        toastOptions.contentTemplate = "Une erreur est survenue sur le serveur :<br />" + processedMessage;
        notify(toastOptions, "error", 20000);
        return EMPTY;

      }

      return throwError(() => new Error(err))

    }));
  }
}
